import React, { useEffect } from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import { AuthProvider, useAuth } from './contexts/AuthContext';
import LoginForm from './components/auth/LoginForm';
import LoginOTP from './pages/LoginOTP';
import ProtectedRoute from './components/auth/ProtectedRoute';
import LogementsPage from './pages/LogementsPage';
import AdminDashboard from './pages/AdminDashboard';
import ComptabiliteDashboard from './pages/ComptabiliteDashboard';
import DocumentVerification from './pages/DocumentVerification';
import DashboardLayout from './components/layouts/DashboardLayout';
import websocketService from './services/websocketService';
import './App.css';

// Composant pour rediriger selon le rôle utilisateur
const UserRedirect = () => {
  const { user } = useAuth();

  const getRedirectPath = () => {
    switch (user?.role) {
      case 'admin-generale':
      case 'agent-boaz':
        return '/admin-dashboard';
      case 'bailleur':
        return '/logements';
      case 'client':
        return '/admin-dashboard'; // CLIENT accède aussi à l'espace souscriptions
      default:
        return '/admin-dashboard';
    }
  };

  return <Navigate to={getRedirectPath()} replace />;
};

function App() {
  // Connexion WebSocket IMMÉDIATE au démarrage de l'application
  useEffect(() => {
    console.log('🚀 App - Initialisation connexion WebSocket immédiate...');
    websocketService.connect();

    // Nettoyage à la fermeture de l'app
    return () => {
      console.log('🔌 App - Déconnexion WebSocket');
      websocketService.disconnect();
    };
  }, []); // [] = Exécuté une seule fois au montage du composant

  return (
    <AuthProvider>
      <Router>
        <div className="App">
          <Routes>
            {/* Route publique pour vérification de documents */}
            <Route path="/verif_doc" element={<DocumentVerification />} />

            <Route path="/login" element={<LoginForm />} />
            <Route path="/login-otp" element={<LoginOTP />} />
            <Route
              path="/"
              element={
                <ProtectedRoute>
                  <UserRedirect />
                </ProtectedRoute>
              }
            />
            <Route
              path="/logements"
              element={
                <ProtectedRoute>
                  <DashboardLayout>
                    <LogementsPage />
                  </DashboardLayout>
                </ProtectedRoute>
              }
            />
            <Route
              path="/admin"
              element={<Navigate to="/admin-dashboard" replace />}
            />
            <Route
              path="/admin-dashboard"
              element={
                <ProtectedRoute>
                  <DashboardLayout>
                    <AdminDashboard />
                  </DashboardLayout>
                </ProtectedRoute>
              }
            />
            <Route
              path="/comptabilite"
              element={
                <ProtectedRoute requiredRole="admin-generale" strictRole>
                  <DashboardLayout>
                    <ComptabiliteDashboard />
                  </DashboardLayout>
                </ProtectedRoute>
              }
            />
            <Route
              path="/agent-dashboard"
              element={<Navigate to="/admin-dashboard" replace />}
            />
            <Route
              path="/bailleur-dashboard"
              element={<Navigate to="/logements" replace />}
            />
            <Route
              path="/client-dashboard"
              element={<Navigate to="/admin-dashboard" replace />}
            />
          </Routes>
        </div>
      </Router>
    </AuthProvider>
  );
}

export default App;
